import { render, staticRenderFns } from "./ListClientPage.vue?vue&type=template&id=06a1ca52"
import script from "./ListClientPage.vue?vue&type=script&lang=js"
export * from "./ListClientPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports